import { render, staticRenderFns } from "./MonthlyThermalModuleProdutionSummary.vue?vue&type=template&id=6bb6fb43"
import script from "./MonthlyThermalModuleProdutionSummary.vue?vue&type=script&lang=js"
export * from "./MonthlyThermalModuleProdutionSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports